import {LabelMedium} from '@hm/fundamental'
import {Stack} from '@mui/material'

import {SlaCommentDisplayItem} from '../../types'

import {CommentsVersionsViewItem} from './CommentsVersionsViewItem'
import {CommentTextContent} from './CommentTextContent'

type SlaCommentsListProps = {
  items: SlaCommentDisplayItem[]
  onOpenVersions?: (item: SlaCommentDisplayItem) => void
}

export const SlaCommentsList = ({items, onOpenVersions}: SlaCommentsListProps) => {
  if (items.length === 0) {
    return null
  }

  return (
    <Stack spacing={2}>
      {items.map((item) => (
        <SlaCommentsListItem key={item.key} item={item} onOpenVersions={onOpenVersions} />
      ))}
    </Stack>
  )
}

type SlaCommentsListItemProps = {
  item: SlaCommentDisplayItem
  onOpenVersions?: (item: SlaCommentDisplayItem) => void
}

const SlaCommentsListItem = ({item, onOpenVersions}: SlaCommentsListItemProps) => {
  const content = (
    <div className="flex flex-col gap-y-4">
      <LabelMedium className="text-foreground_faded">{item.contextLabel}</LabelMedium>
      <CommentTextContent content={item.comment} />
    </div>
  )

  return (
    <CommentsVersionsViewItem
      userName={item.userName}
      date={item.eventDateLabel}
      content={content}
      roleLabel={item.roleLabel}
      onOpen={onOpenVersions ? () => onOpenVersions(item) : undefined}
    />
  )
}
